module.exports = __webpack_public_path__ + "static/media/BannerBottom.b57df128.png";